import React, { useEffect, useState } from 'react';
import { Radar } from 'react-chartjs-2';
import { radarTexts } from '../Data/data';


const RadarChart = (props) => {
    const [ref, setRef] = useState(null);

    useEffect(() => {
        if(ref) {
            const base64Image = ref.toBase64Image('image/png', 1)
            props.setImage(base64Image)
        }
    })

    const data = {
        labels: radarTexts.labels,
        datasets: [
            {
                label: radarTexts.mainHeader,
                data: props.all,  
                backgroundColor: 'rgba(245, 90, 30, 0.2)',
                borderColor: 'rgba(245, 90, 30, 1)',
                borderWidth: 2,
            },
        ],
    }
      
    const options = {
        scales: {
            r: {
                angleLines: {
                    display: true,
                    color: 'lightgrey'
                },
                grid: {
                    display: true,
                    color: 'lightgrey'
                },
                min: 0,
                max: 5,
                ticks: { 
                    stepSize: 1, 
                    size: 5,
                },
                pointLabels: {
                    color: 'black',
                    font: {
                        size: 16
                    }
                }
            }
          },
        plugins: {
            legend: {
                display: false
            }
        },
        animation: false
    }

    return (
        <Radar data={data} options={options} ref={newRef => setRef(newRef)} />
    )
};

export default RadarChart;